module.exports = __webpack_public_path__ + "img/dragon_cemetary_small.7164ac04.png";